
import { useState, useEffect, useRef, useMemo } from 'react';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

// Component Date
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/es';
import dayjs from "dayjs";

import { Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { ClearIconButton } from '../../../../pages/styles';

import { Container, Header, Body, SectionRight, Footer, ContainerSelect, ContainerGroup, ContainerInputsDate, CleanIcon, ContainerDates } from './style';
import { FormButton } from '../../../../pages/styles';

import { useTranslation } from "react-i18next";
import { CardGraphic } from '../../../CardGraphic';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/de';
import moment from "moment";

export const GraphicTrendActiveUsers = ({
    age,
    showDates,
    errorsDate,
    setOpenModalTrendUsers,
    handleFiltersModal,
}) => {

    const { t } = useTranslation();

    const chartRef = useRef(null);


    let options = {
        series: [{
            name: "Desktops",
            data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
        }],
        chart: {
            height: 350,
            type: 'line',
            zoom: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'straight'
        },
        // title: {
        //     text: 'Product Trends by Month',
        //     align: 'left'
        // },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'],
                opacity: 0.5
            },
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
        }
    };

    return (
        <Container>
            <Header>{t('dashboard.licenses.modal.title')}</Header>
            <Body>
                <ContainerGroup>
                    <ContainerSelect>
                        <FormControl sx={{ width: 150 }} size="small">
                            <InputLabel id="demo-select-small-label">{t('dashboard.licenses.modal.time')}</InputLabel>
                            <Select
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={age}
                                label={t('dashboard.licenses.modal.time')}
                                onChange={handleFiltersModal}
                            >
                                <MenuItem value={10}>{t('dashboard.licenses.modal.lastMonth')}</MenuItem>
                                <MenuItem value={20}>{t('dashboard.licenses.modal.last3Month')}</MenuItem>
                                <MenuItem value={30}>{t('dashboard.licenses.modal.last6Month')}</MenuItem>
                                <MenuItem value={40}>{t('dashboard.licenses.modal.personalized')}</MenuItem>
                            </Select>
                        </FormControl>
                    </ContainerSelect>

                    {showDates && (
                        <ContainerDates>
                            <ContainerInputsDate errorstart={errorsDate.startDate}>
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                                    <DatePicker
                                        label={t("common.initDate")}
                                        minDate={moment('2020-03-20')}
                                        maxDate={moment()}
                                        //minDate={dayjs('2020-03-20')}
                                        //maxDate={dayjs()}
                                        slotProps={{ textField: { size: 'small', error: errorsDate.startDate } }}
                                        format="DD/MM/YYYY"
                                    />
                                </LocalizationProvider>
                            </ContainerInputsDate>
                            <ContainerInputsDate errorend={errorsDate.endDate}>
                                <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es">
                                    <DatePicker
                                        label={t("common.lastDate")}
                                        //maxDate={dayjs()}
                                        maxDate={moment()}
                                        slotProps={{ textField: { size: 'small', error: errorsDate.endDate } }}
                                        format="DD/MM/YYYY"
                                    />
                                </LocalizationProvider>
                            </ContainerInputsDate>

                            <Tooltip title={t("common.search")}>
                                <ClearIconButton sx={{ height: 28, width: 28 }}>
                                    <SearchIcon sx={{ height: "20px", width: "20px", color: "white" }} />
                                </ClearIconButton>
                            </Tooltip>

                            <Tooltip title={t("common.cleanFilters")}>
                                <ClearIconButton sx={{ height: 28, width: 28 }}>
                                    <CleanIcon />
                                </ClearIconButton>
                            </Tooltip>
                        </ContainerDates>
                    )}

                </ContainerGroup>

                <div style={{ margin: '0px 50px' }}>
                    <CardGraphic
                        type="line"
                        options={options}
                        series={options.series}
                        chartRef={chartRef}
                    />
                </div>
            </Body>
            <Footer>
                <SectionRight>
                    <FormButton onClick={() => setOpenModalTrendUsers(false)} type='close' variant="outlined">{t('common.close')}</FormButton>
                </SectionRight>
            </Footer>
        </Container>
    )
}
